import Layout from "../views/layout/Layout";

export default {
    path: '/userManage',
    component: Layout,
    redirect: '/userManage/agent',
    meta: {title: '用户管理', icon: 'el-icon-user'},
    children: [{
        path: 'agent',
        name: 'agent',
        component: () => import('@/views/userManage/agent/index'),
        meta: {title: '代理商管理', icon: 'product-cate'},
        auth: 'userManage:agent'
    }, {
        path: 'config/:id',
        name: 'config',
        hidden: true,
        component: () => import('@/views/userManage/agent/config/index'),
        meta: {title: '配置中心', icon: 'product-cate'},
        auth: 'userManage:config'
    }, {
        path: 'rate/:id',
        name: 'rate',
        hidden: true,
        component: () => import('@/views/userManage/agent/rate'),
        meta: {title: '修改分润比例', icon: 'product-cate'},
        auth: 'userManage:rate'
    }, {
        path: 'detail/:id',
        name: 'detail',
        hidden: true,
        component: () => import('@/views/userManage/agent/detail'),
        meta: {title: '代理商详情', icon: 'product-cate'},
        auth: 'userManage:detail'
    },{
        path: 'store-detail/:id',
        name: 'store-detail',
        hidden: true,
        component: () => import('@/views/userManage/agent/storeDetail/store-detail'),
        meta: {title: '商家详情', icon: 'product-cate'},
        auth: 'userManage:store-detail'
    }, {
        path: 'userList',
        name: 'userList',
        component: () => import('@/views/userManage/userList/index'),
        meta: {title: '用户列表', icon: 'product-cate'},
        auth: 'userManage:userList'
    }, {
        path: 'staffList',
        name: 'staffList',
        hidden: true,
        component: () => import('@/views/userManage/staff/staff-list'),
        meta: {title: '员工列表', icon: 'product-cate'},
        auth: 'userManage:staffList'
    }, {
        path: 'timeCardRecord/:mobile',
        name: 'timeCardRecord',
        hidden: true,
        component: () => import('@/views/userManage/userList/timeCardRecord/timeCardRecord'),
        meta: {title: '次卡记录', icon: 'product-cate'},
        auth: 'userManage:timeCardRecord'
    }]
}



// WEBPACK FOOTER //
// ./src/router/userManage.js